import * as z from "zod";

export type DocsConfigId = string & { DocsConfigId: void };
export const DocsConfigIdSchema: z.ZodType<DocsConfigId> = z.string() as any;
export function DocsConfigId(value: string): DocsConfigId {
    return value as unknown as DocsConfigId;
}

export type {
    AIChatConfig,
    AIChatDatasource,
    AIChatLocation,
    AIChatWebsiteDatasource,
    AIModel,
    AmplitudeConfig,
    AnalyticsConfig,
    AnnouncementConfig,
    Availability,
    ClearBitConfig,
    ColorConfig,
    ColorsConfig,
    ColorsConfigV2,
    ColorThemedConfig,
    ColorUnthemedConfig,
    ContentAlignment,
    CssConfig,
    CustomFontConfig,
    CustomFontConfigVariant,
    CustomPageAction,
    DocsBodyConfig,
    DocsLayoutConfig,
    DocsPageActionsConfig,
    DocsSettingsConfig,
    DocsSidebarConfig,
    DocsTabsConfig,
    DocsTabsObjectConfig,
    DocsTabsStyle,
    DocsThemeConfig,
    DocsTypographyConfig,
    DocsTypographyConfigV2,
    EditThisPageLaunch,
    FathomConfig,
    FileIdOrUrl,
    FontConfig,
    FontConfigV2,
    FontDisplay,
    FontStyle,
    FooterLink,
    FooterNavConfig,
    FullStoryAnalyticsConfig,
    GoogleAnalytics4Config,
    GTMConfig,
    HeaderPosition,
    HeapConfig,
    HotJarConfig,
    HttpSnippetLanguage,
    HttpSnippetsConfig,
    IntegrationsConfig,
    IntercomConfig,
    JsConfig,
    JsFileConfig,
    JsRemoteConfig,
    JsScriptStrategy,
    KoalaConfig,
    Language,
    LanguageSwitcherConfig,
    LinkTarget,
    LogRocketConfig,
    MetadataConfig,
    MixpanelConfig,
    NavbarGithubMetadata,
    NavbarLink,
    NavbarLinkDropdownMetadata,
    NavbarLinkMetadata,
    PageActionOption,
    PageActionOptions,
    PageActionsConfig,
    PageWidthSizeConfig,
    PirschConfig,
    PlausibleConfig,
    PostHogConfig,
    ProductSwitcherConfig,
    ProgrammingLanguage,
    RedirectConfig,
    RgbaColor,
    SearchbarPlacement,
    SegmentConfig,
    SizeConfig,
    SwitcherPlacement,
    TabsPlacement,
    ThemedFileId,
    TwitterCardSetting,
    WithPermissions
} from "./shared";
export {
    AgentsConfigSchema,
    AIChatConfigSchema,
    AIChatDatasourceSchema,
    AIChatLocationSchema,
    AIChatWebsiteDatasourceSchema,
    AIModelSchema,
    AmplitudeConfigSchema,
    AnalyticsConfigSchema,
    AnnouncementConfigSchema,
    ApiDefinitionId,
    ApiDefinitionIdSchema,
    AvailabilitySchema,
    ClearBitConfigSchema,
    ColorConfigSchema,
    ColorsConfigSchema,
    ColorsConfigV2Schema,
    ColorThemedConfigSchema,
    ColorUnthemedConfigSchema,
    ContentAlignmentSchema,
    CssConfigSchema,
    CustomFontConfigSchema,
    CustomFontConfigVariantSchema,
    CustomPageActionSchema,
    DocsBodyConfigSchema,
    DocsLayoutConfigSchema,
    DocsPageActionsConfigSchema,
    DocsSettingsConfigSchema,
    DocsSidebarConfigSchema,
    DocsTabsConfigSchema,
    DocsTabsObjectConfigSchema,
    DocsTabsStyleSchema,
    DocsThemeConfigSchema,
    DocsTypographyConfigSchema,
    DocsTypographyConfigV2Schema,
    EditThisPageLaunchSchema,
    EndpointId,
    EndpointIdSchema,
    FathomConfigSchema,
    FileId,
    FileIdOrUrlSchema,
    FileIdSchema,
    FontConfigSchema,
    FontConfigV2Schema,
    FontDisplaySchema,
    FontStyleSchema,
    FooterLinkSchema,
    FooterNavConfigSchema,
    FullStoryAnalyticsConfigSchema,
    GoogleAnalytics4ConfigSchema,
    GTMConfigSchema,
    HeaderPositionSchema,
    HeapConfigSchema,
    HotJarConfigSchema,
    HttpSnippetLanguageSchema,
    HttpSnippetsConfigSchema,
    IntegrationsConfigSchema,
    IntercomConfigSchema,
    JsConfigSchema,
    JsFileConfigSchema,
    JsRemoteConfigSchema,
    JsScriptStrategySchema,
    KoalaConfigSchema,
    LanguageSchema,
    LanguageSwitcherConfigSchema,
    LinkTargetSchema,
    LogRocketConfigSchema,
    MetadataConfigSchema,
    MixpanelConfigSchema,
    NavbarGithubMetadataSchema,
    NavbarLinkDropdownMetadataSchema,
    NavbarLinkMetadataSchema,
    NavbarLinkSchema,
    PageActionOptionSchema,
    PageActionOptionsSchema,
    PageActionsConfigSchema,
    PageId,
    PageIdSchema,
    PageWidthSizeConfigSchema,
    PirschConfigSchema,
    PlausibleConfigSchema,
    PostHogConfigSchema,
    ProductSwitcherConfigSchema,
    ProgrammingLanguageSchema,
    RedirectConfigSchema,
    RgbaColorSchema,
    RoleId,
    RoleIdSchema,
    SearchbarPlacementSchema,
    SegmentConfigSchema,
    SizeConfigSchema,
    SubpackageId,
    SwitcherPlacementSchema,
    TabsPlacementSchema,
    ThemedFileIdSchema,
    TwitterCardSettingSchema,
    Url,
    UrlSchema,
    VersionId,
    VersionIdSchema,
    WebhookId,
    WebhookIdSchema,
    WebSocketId,
    WebSocketIdSchema,
    WithPermissionsSchema
} from "./shared";
